import { PaymentState, PaymentAction } from './payment.types';

export const initialState: PaymentState = {
  paymentSummary: {
    shouldShowPayAtOrder: false,
    shouldDisableWhileImpersonating: false,
    shouldInitiateRequestForPayment: false,
    shouldCollectPayment: false,
    requestForPaymentAmount: undefined,
    isCardEligible: false,
    paymentType: 'Cash',
    totalVehiclePrice: 0,
    purchasePaymentBreakdown: {
      cashDown: 0,
      shippingFee: 0,
      credit: 0,
      amountDue: 0,
      refundDue: 0
    },
    paymentSelection: undefined,
    consents: []
  }
};

export const paymentReducer = (state: PaymentState, action: PaymentAction): PaymentState => {
  switch (action.type) {
    case 'SET_PAYMENT_SUMMARY':
      return {
        ...state,
        paymentSummary: action.payload
      };
    case 'SET_IS_CARD_ELIGIBLE':
      return {
        ...state,
        paymentSummary: {
          ...state.paymentSummary,
          isCardEligible: action.payload
        }
      };
    default:
      throw new Error(`Unhandled action type: ${JSON.stringify(action)}`);
  }
};
